import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import HeaderBread from "../../../../../../components/HeaderBread";
import CustomHeaderTitle from "../../../../../../components/constants/CustomHeaderTitle";
import Layout from "../../../../../../Layout";
import EntertainmentMenuItemInput from "../../../../../../components/EntertainmentMenuItemInput";
import { useDataLayerValue } from "../../../../../../DataLayer/DataLayer";
import {
  getEntertainmentRvc,
  getEntertainmentItemizers,
} from "../../../../../../utils/ApiCalls/BackOffice/Entertainment";

const LIST_PATH = "/shore/back-office/entertainment/revenue-center";

const CreateMenuItem = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [rvc, setRvc] = useState(null);
  const [itemizers, setItemizers] = useState([]);
  const [, dispatch] = useDataLayerValue();

  useEffect(() => {
    const loadData = async () => {
      dispatch({ type: "SET_LOADING", loading: true });
      const rvcData = await getEntertainmentRvc(params.id);
      if (!rvcData.error) {
        setRvc(rvcData);
        const itemizersRes = await getEntertainmentItemizers({
          rvcId: rvcData.id,
          limit: 1000,
        });
        if (!itemizersRes.error) setItemizers(itemizersRes.data || []);
      }
      dispatch({ type: "SET_LOADING", loading: false });
    };
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  const basePath = `${LIST_PATH}/${params.id}`;

  const navigation = [
    { title: "Home", route: "/" },
    { title: "Revenue Center", route: LIST_PATH },
    { title: rvc?.name || "Revenue Center", route: basePath },
    { title: "Add Menu Item", route: `${basePath}/menu-item/add` },
  ];

  return (
    <Layout type={"create_per"} module_data={"Revenue Center"}>
      <CustomHeaderTitle title={"Create Menu Item"} />
      <HeaderBread navigation={navigation} title={"Add Menu Item"}></HeaderBread>
      {rvc && (
        <EntertainmentMenuItemInput
          rvcId={rvc.id}
          rvcName={rvc.name}
          itemizers={itemizers}
          menuItem={{}}
          onSuccess={() =>
            navigate(basePath, { state: { topTab: "menuItem" } })
          }
        />
      )}
    </Layout>
  );
};

export default CreateMenuItem;
